import { useState, useEffect } from 'react';
import { useUIStore } from '../../store/useUIStore';
import { HelpCircle } from 'lucide-react';

export function PromptDialog() {
    const promptState = useUIStore(state => state.promptState);
    const resolvePrompt = useUIStore(state => state.resolvePrompt);
    const [inputValue, setInputValue] = useState('');

    useEffect(() => {
        if (promptState) {
            setInputValue(promptState.defaultValue || '');
        }
    }, [promptState]);

    if (!promptState) return null;

    const { title, message, confirmText = 'Aceptar', cancelText = 'Cancelar' } = promptState;

    const handleSubmit = (e?: React.FormEvent) => {
        if (e) e.preventDefault();
        resolvePrompt(inputValue);
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm animate-fade-in px-4">
            <div className="bg-white rounded-2xl p-6 w-full max-w-md shadow-2xl animate-scale-up">
                <div className="flex items-center gap-4 mb-4">
                    <div className="p-3 rounded-full bg-blue-100 text-blue-600">
                        <HelpCircle className="w-6 h-6" />
                    </div>
                    <h3 className="text-xl font-bold text-slate-800">
                        {title || 'Ingresar Información'}
                    </h3>
                </div>

                <p className="text-slate-600 mb-4 text-sm">{message}</p>

                <form onSubmit={handleSubmit}>
                    <input
                        type="text"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        placeholder="Escribe aquí..."
                        className="w-full px-4 py-2 border border-slate-300 rounded-lg focus:ring-2 focus:ring-primary-500 outline-none transition-all mb-6"
                        autoFocus
                    />

                    <div className="flex gap-3 justify-end">
                        <button
                            type="button"
                            onClick={() => resolvePrompt(null)}
                            className="px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-100 rounded-lg transition-colors border border-slate-200"
                        >
                            {cancelText}
                        </button>
                        <button
                            type="submit"
                            className="px-4 py-2 text-sm font-bold text-white bg-primary-600 hover:bg-primary-700 focus:ring-4 focus:ring-primary-100 rounded-lg transition-colors shadow-sm"
                        >
                            {confirmText}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}
